import { render, staticRenderFns } from "./PayAmount.vue?vue&type=template&id=3338a38d&scoped=true&"
import script from "./PayAmount.vue?vue&type=script&lang=js&"
export * from "./PayAmount.vue?vue&type=script&lang=js&"
import style0 from "./PayAmount.vue?vue&type=style&index=0&id=3338a38d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3338a38d",
  null
  
)

export default component.exports